export const COLLECTION_ROUTE_PATH = '/collection';
export const EXTERNAL_STORAGE_LINK_ROUTE_PATH = '/external-stroage-link';

export const KEYS = {
  STORAGE_COLLECTION_SAMPLE_PCD_DOWNLOADED:
    'STORAGE_COLLECTION_SAMPLE_PCD_DOWNLOADED',
  STORAGE_COLLECTION_LATEST_BUCKET: 'STORAGE_COLLECTION_LATEST_BUCKET',
  STORAGE_COLLECTION_LATEST_DIR_KEY: 'STORAGE_COLLECTION_LATEST_DIR_KEY',
};

export const isPcdItem = (item: { name: string; isDir?: boolean }): boolean =>
  !item.isDir && item.name.toLowerCase().endsWith('.pcd');

export const UPLOADABLE_EXTENSION_LIST = [
  '.pcd',
  '.json',
  '.jpg',
  '.jpeg',
  '.png',
  '.webp',
];
